enum HelpCategory {
  Default = 'Default',
  Internal = 'Internal',
  Urgent = 'Urgent',
  General = 'General',
  Unmind = 'Unmind',
}

export default HelpCategory;
